import React, { useContext, useEffect, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { roles } from "../asset/variables";

export default function UserForm(props) {
    const {updateConnect} = useContext(Context)
    const agent = JSON.parse(sessionStorage.getItem('user'))
    const agentOrganisation = JSON.parse(sessionStorage.getItem('eglise'))
    const [list_eglises, setListEglises] = useState([])
    const [load, setload] = useState(false)
    const [nom, setNom] = useState(props.user?.nom??'')
    const [prenom1, setPrenom1] = useState(props.user?.prenom1??'')
    const [prenom2, setPrenom2] = useState(props.user?.prenom2??'')
    const [identifiant, setIdentifiant] = useState(props.user?.identifiant??'')
    const [mail, setMail] = useState(props.user?.mail??'')
    const [organisation, setOrganisation] = useState(props.user?.organisation?.number??props.eglise?.number??agentOrganisation?.number??'')
    const [eglises, setEglises] = useState(props.eglise?.number?[props.eglise?.number]:[])
    const [access, Setaccess] = useState(props.user?.access??[])
    const [role, setRole] = useState(props.user?.role??'')
    const [msg, setMsg] = useState()

    async function handleSubmit(event) {
        event.preventDefault()
        setload(true); setMsg('')
        
        const userOrganisation = list_eglises.find(item=>item.number===organisation)
        const userEglises = userOrganisation.type==='fédération'? eglises.filter(item=>item!=='') : userOrganisation.number 
        
        if (userOrganisation.type==='fédération'?roles.find(rl=>rl.label===role)?.level<3:roles.find(rl=>rl.label===role)?.level>2) {
            setMsg('Veuillez vérifier l\'organisation sélectionnée')
            setload(false)
            return
        } 
       
        fetch(API.concat(props.edit?`/users/${props.user?._id}`:'/users/create'), {method:props.edit?'PATCH':'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({
                nom, prenom1, prenom2, identifiant, mail, organisation, eglises: eglises.filter(e=>e!==''), access: access.filter(ac=>roles.find(rl=>rl.label===role).access_max.some(am=>am.ref===ac)), role, 
                level: props.edit&&!roles.some(rl=>rl.label===role)? props.user?.level : roles.find(rl=>rl.label===role)?.level
            })
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {user, eglises} = await response.json()
                    const usr = {...user, eglises:eglises.filter(eg=>user.eglises.includes(eg.number)), organisation:eglises.find(eg=>eg.number===user.organisation)}
                    if (props.edit&&user._id===agent._id) {
                        sessionStorage.setItem('user', JSON.stringify(user))
                    }
                    props.add(usr); props.close()
                    setload(false)
                }else {
                    const text = await response.text()
                    setMsg(text)
                    setload(false)
                }
            }
        })
    }

    function Set_organisation(eglise) {
        setOrganisation(eglise)
        setEglises(list_eglises.find(item=>item.number===eglise).type==='fédération'?[]:[eglise])
    }

    useEffect(()=>{
        async function get_eglises() {
            fetch(API.concat('/user/eglises'), {method:'GET', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setListEglises(json)
                    }
                    setload(false)
                }
            })
        }

        get_eglises()
       
    }, [updateConnect])

    return(
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>{props.edit?'Modifier':'Créer'} un utilisateur</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            <Stack direction='column' spacing={2} marginInline='20px'>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Nom" autoComplete="family-name" autoFocus
                    error={/(?:^\s+|\s+$)/.test(nom)} helperText={/(?:^\s+|\s+$)/.test(nom) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    sx={{minWidth:'200px'}} value={nom} onChange={(event)=> setNom(event.target.value)} />
                    <TextField required fullWidth label="Prénom" autoComplete="given-name"
                    error={/(?:^\s+|\s+$)/.test(prenom1)} helperText={/(?:^\s+|\s+$)/.test(prenom1) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    sx={{minWidth:'200px'}} value={prenom1} onChange={(event)=> setPrenom1(event.target.value)} />
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField fullWidth label="Deuxième prénom" autoComplete="given-name" 
                    sx={{minWidth:'200px'}} value={prenom2} onChange={(event)=> setPrenom2(event.target.value)} />
                    <TextField fullWidth label="Identifiant" required
                    sx={{minWidth:'200px'}} value={identifiant} onChange={(event)=> setIdentifiant(event.target.value)} />
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Mail" autoComplete="email"
                    error={/(?:^\s+|\s+$)/.test(mail)} helperText={/(?:^\s+|\s+$)/.test(mail) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    sx={{minWidth:'200px'}} value={mail} onChange={(event)=> setMail(event.target.value)} />
                    {list_eglises.length>0&&agent.eglises.length!==1&&
                    <TextField select label="Organisation" fullWidth required sx={{minWidth:'200px'}} value={organisation} onChange={(event)=> Set_organisation(event.target.value)}>
                        {list_eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(item=><MenuItem key={item._id} value={item.number} sx={{textTransform:'capitalize'}}>{item.nom+' - '+item.commune}</MenuItem>)}
                    </TextField>}
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Rôle" select sx={{minWidth:'200px'}} value={role} 
                    onChange={e=> {
                        setRole(e.target.value); 
                        const ROLE = roles.find(rl=> rl.label===e.target.value)
                        Setaccess(ROLE?.access_max?.map(ac=>ac.ref)); 

                        if (ROLE.level>2&&list_eglises.some(eg=>eg.type==='fédération')) {
                            setOrganisation(list_eglises.find(eg=>eg.type==='fédération').number)
                        }else if(ROLE.level<3&&list_eglises.find(eg=>organisation===eg.number)?.type==='fédération') {
                            setOrganisation('') ; setEglises([])
                        }

                        if(e.target.value==='gestionnaire'){
                            setEglises(old=>Array.isArray(old)? old:[])
                        }else setEglises(old=> old instanceof String?[old]:[''])
                    }}>
                        {(roles.find(rl=>rl.level===agent.level)?.label==="super administrateur"?roles:roles.filter(rl=> rl.level<agent.level)).sort((a, b)=>a.label<b.label?-1:1).map(item=><MenuItem key={item.label} value={item.label} sx={{textTransform:'capitalize'}}>{item.label}</MenuItem>)}
                    </TextField>
                    {(role==="gestionnaire"||(props.edit&&eglises.length>0))&&list_eglises.length>0&&<FormControl fullWidth sx={{ minWidth:'200px'}}>
                        <InputLabel>Églises</InputLabel>
                        <Select fullWidth multiple={roles.find(rl=> rl.label===role)?.level>2} required label="Églises"
                        sx={{minWidth:'200px'}} value={roles.find(rl=> rl.label===role)?.level>2 ? eglises : eglises[0]} onChange={(event)=> {if(roles.find(rl=> rl.label===role)?.level>2){setEglises(event.target.value)} else setEglises([event.target.value])}}>
                            {list_eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).filter(eg=>eg.type==='église').map(item=><MenuItem key={item._id} value={item.number} sx={{textTransform:'capitalize'}}>{item.nom+' - '+item.commune}</MenuItem>)}
                        </Select>
                    </FormControl>}
                </Stack>
                {role!==''&&<FormControl sx={{width:'60%', minWidth:'300px', alignSelf:'center'}}>
                    <InputLabel>Accès</InputLabel>
                    <Select required multiple fullWidth value={access} onChange={e=>Setaccess(e.target.value)} label="Accès">
                        {roles.find(rl=> rl.label===role)?.access_max?.map(ac=><MenuItem key={ac.ref} value={ac.ref}>{ac.label}</MenuItem>)}
                    </Select>
                </FormControl>}
            </Stack>

            <Button variant="contained" type="submit" sx={{marginTop:'20px', borderRadius:0, paddingBlock:1.5}}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}